import { RunwayRainGaugeSettings } from '@mono/types/src/runway-widgets';

export const defaultRunwayRainGaugeSettings: RunwayRainGaugeSettings = {
    title: 'Rainfall',
    aerodrome: 'NZWN',
    thresholds: {
        threeMinute: { value: 0.5, colour: '#FA6161' },
        tenMinute: { value: 10, colour: '#FA6161' },
    },
    defaultColour: '#2476DC',
    weatherStations: ['NZWNA', 'NZWNB'],
    mode: 'cozy',
};
